






import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const TranslateStore = namespace('translate');

@Component({
  name: 'AreYouHealthyComponent'
})
export default class AreYouHealthy extends Vue {

  @TranslateStore.Action
  public healthCheck!: () => Promise<any>;
  
  private response = "";

  private async mounted() {
      this.healthCheck()
      .then((data) => {
        this.response = "Healthy";
      })
      .catch((error: any) => {
        this.response = "Unhealthy"
      });
  }
}
